// Common UI style system
export const UIStyles = {
  // Colors
  colors: {
    primary: '#ffffff',
    secondary: '#777677',
    text: '#1f2539',
    background: '#b38e98',
    buttonText: '#efeee7',
    shineCorrect: 'linear-gradient(90deg, transparent, rgba(0, 255, 136, 0.3), transparent)',
    incorrect: 'rgba(255, 68, 102, 0.3)',
    darkOverlay: 'rgba(0, 0, 0, 0.8)',
    dimmedText: '#0b1626',
    successGreen: '#00ff88',
    errorRed: '#ff4466',
    warningYellow: '#ffcc00',
  },

  // Glassmorphism
  glass: {
    background: 'rgba(37, 34, 36, 0.2)',
    backdropFilter: 'blur(34px)',
    border: 'none',
    boxShadow: 'inset 0 4px 4px 0 rgba(255, 255, 255, 0.25), inset 0 4px 4px 0 rgba(0, 0, 0, 0.25)',
  },
  notification: {
    backdropFilter: 'blur(26.6x)',
    boxShadow: 'inset 0 3px 3px 0 rgba(255, 255, 255, 0.25), inset 0 3px 3px 0 rgba(255, 255, 255, 0.25)',
    background: 'rgba(239, 238, 231, 0.8)',
  },
  stickerCont: {
    backdropFilter: 'blur(25px)',
    boxShadow: 'inset 0 3px 3px 0 rgba(255, 255, 255, 0.25), inset 0 -2px 3px 0 rgba(0, 0, 0, 0.25)',
    background: '#efeee7',
  },

  // Text styles
  text: {
    base: {
      fontFamily: 'Inter, sans-serif',
      textAlign: 'center' as const,
      lineHeight: 1.5,
      margin: 0,
    },
    title: {
      fontSize: '26px',
      fontWeight: 500,
      color: '#ffffff',
    },
    answerButton: {
      fontSize: '16px',
      fontWeight: 300,
      color: '#ffffff',
    },
    subtitle: {
      fontSize: '14px',
      fontWeight: 300,
      color: '#0b1626',
    },
    body: {
      fontSize: '14px',
      color: '#e0e0e0',
      textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
    },
    small: {
      fontSize: '14px',
      color: '#b0b0b0',
    },
    stats: {
      fontSize: '18px',
      fontWeight: 500,
      color: '#ffffff',
    },
  },

  button: {
    base: {
      background: 'rgba(37, 34, 36, 0.2)',
      boxShadow: 'inset 0 4px 4px 0 rgba(255, 255, 255, 0.25), inset 0 -3px 4px 0 rgba(0, 0, 0, 0.25)',
      backdropFilter: 'blur(34px)',
      padding: '13px',
      borderRadius: '27px',
      fontSize: '19px',
      fontWeight: '400',
      lineHeight: 1,
      textAlign: 'center' as const,
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      border: 'none',
      flex: 1,
    },
    hover: {
      background: 'rgba(37, 34, 36, 0.4)',
      boxShadow: '0 0 7px rgba(255, 255, 255, 0.5)',
    },
    onMouseEnter: (e: React.MouseEvent<HTMLButtonElement>) => {
      e.currentTarget.style.backgroundColor = UIStyles.button.hover.background;
      e.currentTarget.style.boxShadow = UIStyles.button.hover.boxShadow;
    },
    onMouseLeave: (e: React.MouseEvent<HTMLButtonElement>) => {
      e.currentTarget.style.boxShadow = 'none';
      e.currentTarget.style.backgroundColor = UIStyles.button.base.background;
    },
  },

  // Container styles
  container: {
    panel: {
      background: 'rgba(0, 0, 0, 0.8)',
      backdropFilter: 'blur(10px)',
      borderRadius: '20px',
      padding: '20px',
      border: '2px solid rgba(255, 255, 255, 0.2)',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.5)',
    },
    dialog: {
      background: 'rgba(30, 40, 80, 0.9)',
      backdropFilter: 'blur(20px)',
      borderRadius: '20px',
      padding: '25px',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      boxShadow: '0 20px 40px rgba(0, 0, 0, 0.5)',
    },
  },

  // Animation keyframes
  animations: {
    float: `
      @keyframes float {
        0%, 100% { transform: translateY(0px) rotate(0deg); }
        50% { transform: translateY(-15px) rotate(2deg); }
      }
    `,
    shine: `
      @keyframes shine {
        0% { left: -100%; }
        100% { left: 100%; }
      }
    `,
    bounce: `
      @keyframes bounce {
        0%, 80%, 100% {
          transform: scale(0.8);
          opacity: 0.5;
        }
        40% {
          transform: scale(1.2);
          opacity: 1;
        }
      }
    `,
    pulse: `
      @keyframes pulse {
        0% { transform: scale(1); opacity: 1; }
        50% { transform: scale(1.05); opacity: 0.8; }
        100% { transform: scale(1); opacity: 1; }
      }
    `,
    fadeIn: `
      @keyframes fadeIn {
        from { opacity: 0; transform: translateY(-20px); }
        to { opacity: 1; transform: translateY(0); }
      }
    `,
  },
};